module.exports = __webpack_public_path__ + "img/login-bg.900fcf8.jpeg";